/**
 * The below file is the Fire Class service which contains method for doing the API calls.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Get_All_Fire_Class,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const FireClassService = {};

//#region Method for Fire Class dropdown

/**
 * Method for getting the Fire Class dropdown
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
FireClassService.getAllFireClass = function () {
  return fetch({
    url: Get_All_Fire_Class,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
  });
};

//#endregion Method for Fire Class dropdown.

export default FireClassService;
